/**
* User management & login
*/
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider
        .state('member', {
            url: '/' + urls.member.fr, // TODO : when multilang, change this to something dynamic
            abstract: true,
            resolve: {
                auth: function ($q, profile) {
                    var deferred = $q.defer();
                    profile.claim().then(function (authorization) {
                        if (authorization.authenticated) {
                            if (authorization.role === 'member' || authorization.role === 'administrateur' || authorization.role === 'instructor' || authorization.role === 'rtq') {
                                deferred.resolve(authorization);
                            } else {
                                deferred.reject({ status: 'ACCOUNT_LOGIN__ADMIN' });
                            }
                        } else {
                            deferred.reject({ status: 'ACCOUNT_LOGIN__REDIRECT' });
                        }
                    }).catch(function () {
                        deferred.reject({ status: 'ACCOUNT_LOGIN__ERROR' });
                    });
                    return deferred.promise;
                },
                nationalities: function (drupal) {
                    return drupal.getNationalities();
                }
            },
            controller: ['$scope', '$rootScope', '$state', '$filter', 'headermanager', 'profile', 'lodash', 'drupal', function ($scope, $rootScope, $state, $filter, $headermanager, $profile, lodash, drupal) {
                // layout init
                $headermanager.customize({
                    filled: true
                });

                $scope.member = $profile.info;
                $scope.memberRole = $profile.authorization.role;
                $scope.instructor = $profile.authorization.role === $profile.roles.instructor;

                $scope.config = $rootScope.config.site;

                $scope.breadcrumb = [
                    { label: $filter('translate')('home'), state: 'homepage' },
                    { label: $filter('translate')('account.myAccount') , state: 'member.home' }
                ];
                $scope.showTrainings = true;
                if( $scope.config.account_trainings.show_trainings === 1) {
                    $scope.showTrainings = true;
                }
                $scope.menus = [];
                //angular.copy($headermanager.accountMenu.submenu, $scope.menus);
                // directly bind to headerpanel menu model to update responsive access menu
                $scope.menus = $headermanager.accountMenu.submenu;
                if( !$scope.showTrainings ){
                    $scope.menus[3].label = $filter('translate')('account.myTrainingsDocuments');
                    $scope.menus[3].state = 'member.training.documents';
                }
                $rootScope.titlePanel = '';
                var titlepanelWatcher = $rootScope.$watch('titlePanel', function (value) {
                    $scope.title = value;
                });
                $scope.teaserPanel = {};

                // display warning if there are missing information
                // TODO: change condition if more conditions are mandatory
                if (!$scope.member.field_nom) {
                    angular.merge($scope.teaserPanel, { css: 'warning', body: $rootScope.config.site.account_content.account_info_warning.value });
                }

                // active menu handler (layout)
                $scope.isActive = function (current) {
                    var state = current.parentState || current.state;
                    return $state.includes(state);
                };

                $scope.$on('$destroy', function () {
                    titlepanelWatcher();
                });
            }],
            templateUrl: 'src/views/member/member_layout.html'
        })
        .state('member.home', {
            url: '',
            views: {
                aside: {
                    templateUrl: 'src/views/member/member_aside.html'
                },
                content: {
                    controller: ['$rootScope', '$scope', 'tools', '$filter', 'drupal', 'profile', function ($rootScope, $scope, tools, $filter, drupal, profile) {
                        if ($scope.breadcrumb.length > 2) {
                            $scope.breadcrumb.pop();
                        }
                        $rootScope.titlePanel = tools.replace($filter('translate')('account.welcome'), { name: $scope.member.field_prenom || '' });
                        $scope.content = {};

                        // warning message
                        drupal.getAccountOrders(profile.info.field_sfid).then(function (orders) {
                            var pendingOrders = orders.filter(function (o) {
                                return o.balance > 0;
                            });
                            if (pendingOrders.length) {
                                angular.merge($scope.teaserPanel, { css: 'info', body: $rootScope.config.site.account_warning });
                            }
                        });
                    }],
                    templateUrl: 'src/views/member/member_home.html'
                }
            }
        });
}]);
